import { FunctionComponent } from "react";

import { Link } from "react-router-dom";

import { faChevronDoubleDown, faChevronDoubleUp } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

import { ListPerson } from "../../../schema/list";

type Offer = ListPerson["offer"];

/**
 * The collapsible "Related Job" section shown below the Overview tab's column
 * grid. Extracted from {@link DetailView} to keep that file within the
 * 500-line limit. The work history moved into the person identity card's
 * "See work history" expander ({@link ListPersonHeader}).
 */
export const DetailViewOverviewSections: FunctionComponent<{
	offer?: Offer;
}> = ({ offer }) => (
	<>
		{offer?.companyName && (
			<details className="flex group w-full flex-col border border-gray-200 rounded-lg p-4 mt-4">
				<summary className="cursor-pointer flex bg-white flex-row items-start w-full justify-between gap-2">
					<h3 className="text-sm font-semibold text-gray-900">Related Job</h3>
					<div className="flex flex-row gap-2 justify-center items-center text-sm group-open:hidden">
						<p>Show More</p>
						<Icon className="cursor-pointer text-sm w-3 h-3" icon={faChevronDoubleDown} />
					</div>
					<div className="flex flex-row gap-2 justify-center items-center text-sm hidden group-open:flex">
						<p>Show Less</p>
						<Icon className="cursor-pointer text-sm w-3 h-3" icon={faChevronDoubleUp} />
					</div>
				</summary>
				<div className="flex flex-col mt-3">
					{offer.jobTitle && (
						<div className="mb-2">
							<div className="text-sm font-semibold">{offer.jobTitle}</div>
							{offer.description && (
								<div className="text-sm text-gray-700 mt-1">{offer.description}</div>
							)}
						</div>
					)}
					{(offer.jobCity || offer.jobState || offer.jobCountry) && (
						<div className="text-sm text-gray-600 mb-2">
							{offer.jobCity ? `${offer.jobCity}, ` : ""}
							{offer.jobState ? `${offer.jobState}, ` : ""}
							{offer.jobCountry}
						</div>
					)}
					{offer.offerLink && (
						<Link
							className="text-sm text-blue-600 hover:underline"
							target="_blank"
							to={offer.offerLink}
						>
							View job offer
						</Link>
					)}
				</div>
			</details>
		)}
	</>
);
